// Libraries
import React from 'react';
import {css} from 'aphrodite/no-important';
// Core
import CoreMetrics, {createExpandableMediaQueryStylesheet} from '../core/Metrics';
import {LabelMediumText} from '../core/Type';
import {generateID} from '../core/Utilities';

export default class TabBar extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            tabBar: {
                display: "flex",
                flexDirection: "row",
                flexWrap: "nowrap",
                alignItems: "stretch",
                height: "100%",
                margin: 0,
                padding: 0,
            },
            tab: {
                display: "flex",
                flexDirection: "row",
                position: "relative",
                padding: 0,
                marginTop: 0,
                marginBottom: 0,
                marginLeft: 0,
                marginRight: CoreMetrics.ElementSpacing.Medium(),
                ":last-of-type": {
                    marginRight: 0,
                },
            },
            radio: {
                "-webkit-appearance": "none",
                position: "absolute",
                height: "100%",
                width: "100%",
                ":focus": {
                    outline: "none",
                },
            },
            label: {
                userSelect: "none",
                alignSelf: "center",
            },
            selectedLabel: {
                color: CoreMetrics.Color.Control.Default,
            },
            selectionBar: {
                position: "absolute",
                bottom: 0,
                width: "100%",
                height: 2,
                borderRadius: 1,
                backgroundColor: CoreMetrics.Color.Control.Default,
            },
        });

        const {items, selectedIndex} = this.props;
        let children = [];
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            const checked = (i === selectedIndex);
            const id = this.props.id;
            const itemID = id + "-item-" + i;
            const radioID = id + "-radio-" + i;
            const labelID = id + "-label-" + i;
            const barID = id + "-bar-" + i;
            let labelStyles = [styles.label];
            if (checked) {
                labelStyles.push(styles.selectedLabel);
            }
            let subElements = [
                <input key={radioID} id={radioID} className={css(styles.radio)} type="radio" onChange={this.handleChange} checked={checked} />,
                <LabelMediumText key={labelID} styles={[labelStyles]}>{item}</LabelMediumText>,
            ];
            if (checked) {
                subElements.push(<div key={barID} className={css(styles.selectionBar)}></div>);
            }
            const itemElement = (
                <div key={itemID} className={css(styles.tab)}>
                    {subElements}
                </div>
            );
            children.push(itemElement);
        }
        return (
            <form className={css(styles.tabBar)}>
                {children}
            </form>
        );
    }
    handleChange = (event) => {
        const element = event.target;
        const id = element.id;
        const i = id.match(/(\d+)$/)[0];
        const changeHandler = this.props.changeHandler;
        if (changeHandler != null) {
            changeHandler(i);
        }
    }
}
TabBar.defaultProps = {
    id: generateID()
};



// WEBPACK FOOTER //
// ./src/controls/TabBar.jsx